import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ChartContainer = styled.div`
  width: 100%;
  height: 500px;
`;

export const TickContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 22px 0;
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  margin-bottom: 20px;
`;

export const Title = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
  margin-top: 20px;
`;

export const QuestionOrder = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 16px;
  font-family: Roboto;
`;

export const ContainerLabels = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
`;
